<template>
    <b-navbar :spaced="false" :shadow="true">
        <template slot="brand">
            <b-navbar-item tag="router-link" :to="{ path: '/' }">
                Apple Parts Finder
            </b-navbar-item>
        </template>

        <template slot="end">
            <b-navbar-item tag="div">
                <div class="buttons">
                    <b-button
                        v-if="newSearchButtonActive"
                        @click="newSearchClicked"
                        type="is-primary">
                        New Search
                    </b-button>
                </div>
            </b-navbar-item>
        </template>
    </b-navbar>
</template>

<script>

export default {
  name: "Navbar",
  methods: {
      newSearchClicked () {
          this.$emit('newSearch');
      }
  },
  props: {
    newSearchButtonActive: {
      type: Boolean,
      required: true
    },
  }
};

</script>

<style scoped>


</style>